import { render } from "./Stats.vue?vue&type=template&id=4f86c5c0"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"
script.render = render

export default script